import { useQuery } from '@tanstack/react-query';
import { useCallback, useContext } from 'react';
import { ChatMetadata } from 'types';
import { apiUrl, CHATBOT_KEY, fetchWithAuth, USE_QUERY_STALE_TIME } from 'utils';
import { AuthContext } from 'contexts';

export function useChatbotList() {
  const authContext = useContext(AuthContext);

  const queryFn = useCallback(async (): Promise<ChatMetadata[]> => {
    const response = await fetchWithAuth(`${apiUrl}/chat-metadata`);
    const ret: ChatMetadata[] = await response.json();

    if (!ret || !ret.length) {
      return [];
    }

    return ret;
  }, []);

  const query = useQuery<ChatMetadata[]>({
    queryKey: [CHATBOT_KEY],
    queryFn,
    staleTime: USE_QUERY_STALE_TIME,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    enabled: authContext.isAuthenticated,
  });

  return {
    isLoading: query.isLoading,
    isFetching: query.isFetching,
    isError: query.isError,
    isSuccess: query.isSuccess,
    data: query.data,
    refetch: query.refetch,
  };
}
